export default __webpack_public_path__ + "static/slide4-3899edef7eb00eb6b24cd1d4e579ea9e.jpg";